import { secureModeFirmwareVersions } from '../../../../helpers/constants';

export default {
	title: 'settings',
	components: [
		{ title: 'eco_mode', component: 'eco_mode_g2' },
		{
			title: 'enhanced_security',
			component: 'enhanced_security_g2',
			min_ver: secureModeFirmwareVersions,
		},
		{ title: 'device_profile', component: 'cover_profile' },
		{ title: 'input_type', component: 'input_type_g2_cover' },
		{ title: 'lock_inputs', component: 'lock_inputs_g2', min_ver: '1.6.0' },
		{
			title: 'idle_power_threshold',
			component: 'idle_power_threshold_g2',
			min_ver: '0.11.4',
		},
		{
			title: 'idle_confirm_period',
			component: 'idle_confirm_period_g2',
			min_ver: '0.11.4',
		},
		{ title: 'control_button_mode', component: 'control_button_mode_g2' },
		{ title: 'reverse_directions', component: 'reverse_direction_g2' },
		{ title: 'swap_inputs', component: 'swap_inputs_g2' },
		{ title: 'calibration', component: 'calibration_g2' },
		{ title: 'action_on_power_on', component: 'action_on_power_on_g2_cover' },
		{ title: 'movement_time_limits', component: 'movement_time_limits_g2' },
		{
			title: 'blinds_tilt_control',
			component: 'blinds_tilt_control_g2',
			min_ver: '1.4.99',
		},
		{
			title: 'operational_counters',
			component: 'operational_counters_g2',
			requires_operational_counters: true,
		},
		{ title: 'device_name', component: 'device_name_g2' },
		{ title: 'firmware_version', component: 'firmware_update' },
		{ title: 'geo_location_and_time_zone', component: 'location_g2' },
		{ title: 'device_reboot', component: 'device_reboot' },
		{ title: 'factory_reset', component: 'factory_reset' },
		{ title: 'device_information', component: 'device_information' },
	],
};
